"use client";

import { useTranslation } from "react-i18next";
import WhatsAppIcon from "@/components/WhatsAppIcon";

const WHATSAPP_NUMBER = "5492944636295";
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;

export default function WhatsAppButton() {
  const { t } = useTranslation();

  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex min-h-[48px] min-w-[48px] items-center justify-center rounded-2xl shadow-lg transition hover:scale-110 focus:outline-none focus:ring-2 focus:ring-[#25D366]/50 safe-area-inset-bottom"
      aria-label={t("footer.whatsapp")}
    >
      <WhatsAppIcon size={48} className="h-12 w-12 rounded-2xl" />
    </a>
  );
}
